module.exports = __webpack_public_path__ + "img/5.b15d30af.gif";